// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.test_attribute_phase_enum */
var TestAttributePhaseEnum;
(function (TestAttributePhaseEnum) {
    TestAttributePhaseEnum["PREP"] = "PREP";
    TestAttributePhaseEnum["MEASURE"] = "MEASURE";
    TestAttributePhaseEnum["RESULT"] = "RESULT";
    TestAttributePhaseEnum["REVIEW"] = "REVIEW";
})(TestAttributePhaseEnum || (TestAttributePhaseEnum = {}));
;
export default TestAttributePhaseEnum;
/** Zod schema for test_attribute_phase_enum */
export const testAttributePhaseEnum = z.nativeEnum(TestAttributePhaseEnum);
//# sourceMappingURL=TestAttributePhaseEnum.js.map